import React, { FC, useState } from 'react';

import { StandardTextFieldProps, Stack, Box, IconButton } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import { StyledInput } from './styled';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
interface CustomTextField extends Omit<StandardTextFieldProps, 'variant'> {
  placeholder?: string | undefined;
  label?: string;
  labelColor?: string;
  bgcolor?: string;
  width?: string;
  variant?: 'outlined' | 'standard';
  isPassword?: boolean;
}

export const Input: FC<CustomTextField> = ({
  placeholder,
  isPassword = false,
  label,
  bgcolor = '#F1F3F8',
  width = '100%',
  variant = 'standard',
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(show => !show);
  return (
    <Stack spacing={1} sx={{ marginTop: 0 }} flexDirection="row">
      <StyledInput
        bgcolor={bgcolor}
        variant={variant}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          disableUnderline: true,
          endAdornment: isPassword && (
            <Box
              pr={1}
              right="8px"
              display="flex"
              alignItems="center"
              position="absolute"
              justifyContent="center"
            >
              <IconButton onClick={handleClickShowPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </Box>
          ),
        }}
        InputLabelProps={{
          shrink: true,
          style: {
            color: '#2A3453',
            fontSize: '14px',
            fontWeight: '500',
            height: '17px',
            lineHeight: '17px',
          },
        }}
        sx={{ width: width }}
        fullWidth={!!width}
        label={label}
        placeholder={placeholder}
        {...props}
      />
    </Stack>
  );
};
